module.exports = __webpack_public_path__ + "static/media/Camera.4594461d.gif";